//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dedicatedItem from '../../../../../../../local/vue.js/v-dedicated-solution-item/v-dedicated-solution-item.vue';
import dedicatedFilter from '../../../../../../../local/vue.js/v-dedicated-solutions-filter/v-dedicated-solutions-filter.vue';
import {jFunc} from "../../../../../../js/jfunctions.min";

export default {
  name: "choise-ssl",
  components: {},
  data() {
    return {
      ITEMS : {},
      FILTER : {},
      selected : {
        PROPERTIES : {},
        FIELDS : {},
      },
      PARAMS : {},
    }
  },
  methods: {
    add2basket(item) {
      let self = this;

      let validationResult = true;
      ['SSL_DOMAIN', 'SSL_EMAIL', 'SSL_MONTHS'].forEach(function(key) {
        if(!$.trim(item[key])) {
          $('[name="' + key + '"]').css('box-shadow', '0 0 8px 0 #f00');
        }
        else {
          $('[name="' + key + '"]').css('box-shadow', 'unset');
        }

          validationResult = validationResult && !!$.trim(item[key]);

      });

      if(validationResult) {
        let postData = {
          'action': 'add',
          'ID': item.ID,
          'MONTHS': item.SSL_MONTHS,
        };

          item.SSL_EMAIL = $.trim(item.SSL_EMAIL);

        let domain = $.trim(item.SSL_DOMAIN);
        let certsWithPrefix = jFunc.getNested(window, 'AAM', 'CERTS_WITH_WWW_SECTIONS_IDS') || [];
        if(
            certsWithPrefix.indexOf(item.IBLOCK_SECTION_ID) > -1 && domain.indexOf('www.') == -1
            &&
            !jFunc.getNested(item, 'PROPERTIES', 'PLUS_WC', 'VALUE')
        )
          domain = 'www.' + domain;

        if(item.SSL_APPROVER_METHOD == 'auth_email') {
          postData.CONFIGURATION = {
            'SSL_DOMAIN' : domain,
            'SSL_EMAIL' : item.SSL_EMAIL + '@' + self.getMainDomain(item.SSL_DOMAIN),
            'SSL_APPROVER_METHOD' : 'auth_email',
          };
        }
        else {
          postData.CONFIGURATION = {
            'SSL_DOMAIN' : domain,
            'SSL_APPROVER_METHOD' : 'auth_dnstxt',
          };
        }

        $.ajax({
          url: "/local/ajax/basket.php",
          type: "POST",
          data: postData,
          success: function(response) {
            AAM.TopBasket.refresh();
            AAM.showBasketSuccessPopup();
            self.$set(item, 'SHOW_POPUP', false);
          },
        });
      }

    },
      getMainDomain(domain) {
        return domain.split('.').slice(-2).join('.');
      },
    getItemPrice(item) {
      const self = this;
      const discountPercent = (typeof window  != 'undefined' ) ? jFunc.getNested(window, 'AAM', 'PERSONAL_DISCOUNT', 'SSL') || 0 : 0;
      let price = +item.PRICES.BASE.DISCOUNT_VALUE;

      return new Intl.NumberFormat().format(price - (price / 100) * discountPercent) + ' ₽';
    },
  },
  computed : {
    filteredItems() {
      let self = this;
      let result = [];

      if(self.PARAMS.SHOW_FILTER != 'Y') {
        return self.ITEMS;
      }

      for(let itemIndex in self.ITEMS) {
          let currentItem = self.ITEMS[itemIndex];
          let itemResult = true;

        for(let propCode in self.selected.PROPERTIES) {
            let currentProperty = self.selected.PROPERTIES[propCode];
            let propertyResult = !Object.keys(currentProperty).length;

            currentProperty.forEach(function(variant) {
              propertyResult = propertyResult || (currentItem.PROPERTIES[propCode].VALUE == variant);
            });

          itemResult = itemResult && propertyResult;
        }

        for(let fieldCode in self.selected.FIELDS) {
          let currentField = self.selected.FIELDS[fieldCode];
          let fieldResult = !Object.keys(currentField).length;

          currentField.forEach(function(variant) {
            fieldResult = fieldResult || (currentItem[fieldCode] == variant);
          });

          itemResult = itemResult && fieldResult;
        }


        if(itemResult) {
          result.push(currentItem);
        }
      }

      return jFunc.sortArrayOfObjectsByKeyValue(result, 'SORT');
    },
  },
  mounted() {
    let self = this;

    for(let itemIndex in self.ITEMS) {
      self.$set(self.ITEMS[itemIndex], 'SHOW_POPUP', false);
      self.$set(self.ITEMS[itemIndex], 'SSL_EMAIL', 'administrator');
      self.$set(self.ITEMS[itemIndex], 'SSL_DOMAIN', '');
      self.$set(self.ITEMS[itemIndex], 'SSL_MONTHS', 12);
      self.$set(self.ITEMS[itemIndex], 'SSL_APPROVER_METHOD', 'auth_email'); // auth_dnstxt
    }

    for(let propertyCode in self.FILTER.PROPERTIES) {
        self.$set(self.$data.selected.PROPERTIES, propertyCode, []);
    }

    for(let fieldCode in self.FILTER.FIELDS) {
        self.$set(self.$data.selected.FIELDS, fieldCode, []);
    }

    $('.choice-ssl-filter-open').click(function() {
      $('.choice-ssl-filter').addClass('active');
      $('.overlay').addClass('active');
    });
    $('.overlay').on('click', function () {
      if ($('.choice-ssl-filter').hasClass('active')) {
        $('.choice-ssl-filter').removeClass('active');
        $('.overlay').removeClass('active');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./depohost.ru/local/templates/depohost/components/bitrix/catalog.section/v-choise-ssl/template.vue